//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import NoDataDisplay from "@/pccomponents/NoDataDisplay";
export default {
  name:'SelectTreeInfo',
  components: {
      NoDataDisplay
  },
  props:{
    //部门选择框是否是多选
    isMultiple:{
      type: Boolean,
      default: true
    },
    //当前行项的index
    rowindex:{
      type: Number,
      default: -1
    },
    //回调函数
    callbackFun:{
      type:Function,
      default:null
    },
    //弹出框所需数据
    bindData:{
      type:Object,
      default: () => ({})
    }
  },
  data() {
    return {
      //控制弹出框的显示
      dialogVisible: false,
      //存储左侧的树列表数据
      deptList: [],
      //存储已经选择部门列表
      selectDeptList:[],
      //存储树的配置选项
      defaultProps: {
        //指定树中用于展示的数据
        label: 'deptname',
        //指定树中用于包含子节点的属性名
        children: 'children',
      },

      //配置行项显示格式
      configDataFormat: [
        {prop: 'deptid', label: '部门ID'},
        {prop: 'deptname', label: '部门名称'}
      ],
    }
  },
  created() {
    //当传入bindData时，初始化所需值
    if(Object.keys(this.bindData).length!=0){
      this.title=this.bindData.configinfo.chselectwintype;
      this.selectType=this.bindData.selecttype;
      for(let showinfo of this.bindData.showinfo){
        this.configParams.push(showinfo.FIELD);
      }
    }
  },
  mounted() {
  },
  methods: {
    //初始化树结构
    initTree(){
        let url = "deptController/initTree";
        let params = {

        };
        axios.post(url, params).then(({ data }) => {
            this.deptList = data.data.deptList;
        });
    },
    /**
     * 打开选择框
     */
    openSelectData(){
      //初始化树列表
      //if(this.deptList&&this.deptList.length==0){
        this.initTree();
      //}
      this.dialogVisible=true;
    },
    /**
     * 点击确认，回写信息到表单
     */
    submitSelectData() {
      this.dialogVisible = false

      if(this.callbackFun){
        //有回调函数，传入的同步数据是对象时使用
        for(let configParam of this.configParams){
            let echoData=''
            for(let dataCollect of this.selectdata){
                echoData=echoData+'|'+dataCollect[configParam]
            }
            this.returnData[configParam]=echoData
        }
        let params = {
            rowindex : this.rowindex,
            returnData : this.returnData
        }
        this.callbackFun(params);
      }else{
        //没有回调函数，传入的同步数据是字符串时使用
        for(let configParam of this.configParams){
            let echoData=''
            for(let dataCollect of this.selectdata){
                echoData=echoData+'|'+dataCollect[configParam]
            }
            this.$emit('update:'+configParam, echoData)
        }
      }
    },
    /**
     * 点击清空
     */
    clearSelectData(){
      //清空回填的数据
      if(this.callbackFun){
        //有回调函数，传入的同步数据是对象时使用
        const keys=Object.keys(this.returnData)
        keys.forEach(key=>{this.returnData[key] = ''})
        let params = {
            rowindex : this.rowindex,
            returnData : this.returnData
        }
        this.callbackFun(params);
      }else{
        //没有回调函数，传入的同步数据是字符串时使用
        for(let configParam of this.configParams){
            this.$emit('update:'+configParam, '')
        }
      }

      //清空左侧树的选择状态
      this.deptList=[];
      //清空右侧行项列表的选择状态
      this.selectdata=[];
    },
    /**
     * 点击取消按钮，关闭弹出框
     */
    cancelSelect() {
      this.dialogVisible = false;
    },
    /**
     * 复选时的点击事件
     */
    selectPluralDataClick() {
      let selectDatas=this.$refs.tree.getCheckedNodes();

      this.selectdata.length=0
      for(let selectData of selectDatas){
        if(selectData.children&&selectData.children.length!=0){
          continue
        }
        let obj = {};
        for(let configParam of this.configParams){
          obj[configParam] = selectData[configParam];
        }
        this.selectdata.push(obj)
      }
    },
    /**
     * 单选时的点击事件
     */
    selectSingleDataClick(row) {
      console.log(row);
     // if(row&&row.children.length==0){
        let obj = {};
        for(let configParam of this.configParams){
          obj[configParam] = row[configParam];
        }
        this.selectdata.length=0
        this.selectdata.push(obj)
    // }
    },
    /**
     * 删除已选
     */
    delDblclick(row) {
      for (let i = 0; i < this.selectdata.length; i++) {
        if (this.selectdata[i] === row) {
          this.selectdata.splice(i, 1)
        }
      }
    },
    openModel() {
        this.setDialogPos();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pccomponents/SelectTreeInfo.vue